import './Editor.css'

import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import _ from 'lodash'
import { useMemo, useRef } from 'react'

const TOOLBAR_CONFIG = [
  'fontfamily',
  'fontsize',
  'fontColor',
  'fontBackgroundColor',
  '|',
  'bold',
  'italic',
  'underline',
  'strikethrough',
  '|',
  'alignment',
  '|',
  'numberedList',
  'bulletedList',
  '|',
  'outdent',
  'indent',
  '|',
  'link',
  'blockquote',
  'insertTable',
  '|',
  'undo',
  'redo'
]

/**
 * Editor WYSIWYG basato su CKEditor 5 Decoupled
 * @param {Object} props
 * @param {string} props.id - Identificativo univoco del campo editor
 * @param {Function} props.onChange - Callback invocata con l'oggetto { [id]: htmlContent }
 * @param {string} props.initialValue - Contenuto HTML iniziale
 */
const Editor = ({ id, onChange, initialValue }) => {
  const editorRef = useRef(null)

  const debouncedChange = useMemo(
    () =>
      _.debounce((editor, fieldId, cb) => {
        if (!editor.getData()) return cb({ [fieldId]: '' })
        const data = '<div class="ck-content">' + editor.getData() + '</div>'
        cb({ [fieldId]: data })
      }, 600),
    []
  )

  const customConfig = { toolbar: TOOLBAR_CONFIG, extraPlugins: [] }

  return (
    <div className="nora-editor">
      <CKEditor
        onReady={(editor) => {
          editorRef.current = editor
          editor?.ui
            ?.getEditableElement()
            ?.parentElement?.insertBefore(
              editor?.ui?.view?.toolbar?.element,
              editor?.ui?.getEditableElement()
            )
        }}
        onError={({ willEditorRestart }) => {
          if (willEditorRestart) {
            editorRef.current?.ui?.view?.toolbar?.element?.remove()
          }
        }}
        config={customConfig}
        onChange={(event, editor) => {
          debouncedChange(editor, id, onChange)
        }}
        editor={DecoupledEditor}
        data={initialValue}
      />
    </div>
  )
}

export { Editor }
